import { ShiftStatusType, ShiftMetaType } from "@/types/db/shifts";

export type ShiftLocationForm = {
  id: string;
  name: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
};

export type ShiftAbilityForm = {
  ability: {
    id: string;
    name: string;
    description?: string;
  };
};

export type ShiftRestrictionForm = {
  restriction: {
    id: string;
    name: string;
    description?: string;
  };
};

export type ShiftForm = {
  name?: string;
  description?: string;
  project_id?: string;
  client_id?: string;
  status: ShiftStatusType;
  start_time?: string | null;
  end_time?: string | null;
  meta_data?: ShiftMetaType;
  location_id?: string;
  location?: ShiftLocationForm;
  shift_abilities?: ShiftAbilityForm[];
  shift_restrictions?: ShiftRestrictionForm[];
};

export type ShiftPayload = {
  shift: ShiftForm;
};
